import Text from 'components/corporatiu/Text';
import Titol from 'components/corporatiu/Titol';
import __isEmpty from 'lodash/isEmpty';
import styles from './organs.module.scss';
import Imatge from 'components/corporatiu/Imatge/Imatge';

export default function Organs(props) {
    const { items } = props;

    return (
        <>
            <Titol titol={items?.titol} tipus='menu' tag='h1' estil='titolPagina' />
            {items?.imatge && (
                <div className={styles.imatge}>
                    <Imatge src={items?.imatge} width={800} height={450} alt={items?.alt_imatge} priority={false} />
                </div>
            )}
            <Text text={items?.entradeta} className='gapAfterRow' />

            {!__isEmpty(items) &&
                items?.noticies?.map((item) => (
                    <div key={`notis-${item.titol}`}>
                        <div className='gapAfterRow'>
                            <Text text={item.titol} tag='h2' />
                            <Text text={item.entradeta} tag='div' />
                        </div>
                    </div>
                ))}
        </>
    );
}
